module.exports = __webpack_public_path__ + "img/teams.5db9eab8.svg";